import VueI18n from 'vue-i18n';
import es from '@/locales/es.json';
import en from '@/locales/en.json';
import ca from '@/locales/ca.json';
import { initLibTranslation } from '@dinapsis/web-components/dist/lib/i18n/config-locale';

let i18n;
export const initializei18n = () => {
  const messages = {
    en,
    es,
    ca
  };

  i18n = new VueI18n({
    locale: 'es',
    fallbackLocale: 'ca',
    messages
  });
  return i18n;
};

// Set language for dinapsis components
const setDinapsisLanguage = (language) => {
  // Set language for plataforma
  if (language) {
    initLibTranslation(language);
  } else {
    initLibTranslation('es');
  }
};

export const setLanguage = (language) => {
  if (i18n != null) {
    i18n.locale = language;
    setDinapsisLanguage(language);
  }
};
